import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/pro4.png";
import emotion from "../../Assets/Projects/pro3.png";
import editor from "../../Assets/Projects/pro2.png";
import chatify from "../../Assets/Projects/pro1.png";
import suicide from "../../Assets/Projects/todolist.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Personal Card"
              description="A simple, one-page card containing the name and social media links with a beautiful animated background."
              ghLink="https://github.com/Elkalaf820/projectone.github.io"
              demoLink="https://cardonepage.netlify.app"
            />
          </Col>

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Bits-0f-C0de"
              description="My personal blog page build with Next.js and Tailwind Css which takes the content from makdown files and renders it using Next.js. Supports dark mode and easy to write blogs using markdown."
              ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col> */}

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="simple profile"
              description="This website is for introducing the person or institution. It contains the introduction, business, communication and introduction pages. It is just a template and can be modified to suit what the client needs."
              ghLink="https://github.com/Elkalaf820/projectthree"
              demoLink="https://simpleprofiletwo.netlify.app"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="My first portofolio"
              description="This website was my personal portofolio, which I used to introduce myself. It was my first profile, and I used html & css & js on it, and it was simple.."
              ghLink="https://github.com/Elkalaf820/Elkalaf.github.io"
              demoLink="https://mahmoudelkalaf.netlify.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="To Do List"
              description="This application I designed using React and it is a simple to do list."
              ghLink="https://github.com/Elkalaf820/todolist"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" 
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="One page introductory website"
              description="This site is a single page that can be navigated using navbar, which is a template that can be modified as appropriate and contains animations that display images in a beautiful and professional manner."
              ghLink="https://github.com/Elkalaf820/projecttwo.github.io"
              demoLink="https://simpleprofileone.netlify.app"      
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
